module.exports = __webpack_public_path__ + "static/media/card_img_banner.ffd86093.jpg";